module.exports = __webpack_public_path__ + "img/tutorial-2a-sm.3f3dd69a.jpg";